<template>

  <teleport to="body">
    <div v-if="isError" class="modal">
      <div class="error-content">
	<div class="error-title">Error</div>
	<div class="error-message">
	  {{ errorMessage }}
	</div>
	<div class="error-button">
	  <button @click="close" class="greenbtnM">Close</button>
	</div>
      </div>
    </div>
  </teleport>
  
</template>

<script>
import { ref, defineComponent } from 'vue';
import router from '../router';

const isSessionError = ref(false);
const isError = ref(false);
const errorMessage = ref('');

export const session_error = () => {
    error('session expired');
    isSessionError.value = true;
    throw new Error('session error');
};

export const error = (message) => {
    errorMessage.value = message.replace('\\n',"\n");
    isError.value = true;
    isSessionError.value = false;
};
	
export default defineComponent({
    setup() {

	isSessionError.value = false;
	isError.value = false;
	errorMessage.value = '';
    
	const close = () => {
	    isError.value = false;
	    if (isSessionError.value) {
		router.push({name: 'Login'});
	    }
	};

	return {
	    isSessionError,
	    isError,
	    errorMessage,
	    session_error,
	    error,
	    close
	}
    }
});

</script>

<style scoped>
.modal {
    position: fixed;
    top: 0; right: 0; bottom: 0; left: 0;
    background-color: rgba(0,0,0,.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.error-content {
    display: flex;
    flex-direction: column;
    background-color: white;
    width: 300px;
}
.error-title {
    width: 100%;
    font-weight: bold;
}
.error-message {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
}
.error-button {
    display: flex;
    justify-content: center;
    margin-right: 2px;
    margin-bottom: 2px;
}
</style>
